import { useEffect, forwardRef } from "react";
import Product from "../../assets/images/Image 2.png";
import renameimg from "../../assets/images/rename.svg";
import { FormatValueDecimal, CurrencyConvertion, calculateNetPrice } from "../../utils/Validate";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const getOrderProductId = (item) => item?.orderProductId || item?.id;

const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
  <input
    value={value}
    className="example-custom-input form-control"
    onClick={onClick}
    ref={ref}
    placeholder="DD/MM/YYYY"
    readOnly
  />
));
const getProductMatchKeys = (item) => [
    item?.customerOrderProductId,
    item?.quoteProductId,
    item?.orderProductId,
    item?.id,
].filter((value) => value !== null && value !== undefined && value !== "");

const getProductItemMatchKeys = (item) => [
    item?.customerOrderProductItemId,
    item?.quoteProductItemId,
    item?.orderProductItemId,
    item?.customerOrderItemId,
    item?.id,
].filter((value) => value !== null && value !== undefined && value !== "");

const getRemainingReleaseQty = (item) => {
    const orderQty = Number(
        item?.currentOrderQuantity ??
        item?.customerOrderedQuantity ??
        item?.lpoQuantity ??
        item?.orderedQuantity ??
        item?.quantity ??
        item?.qtyValues ??
        0
    );

    const releasedQty = Number(
        item?.factoryReleasedQuantity ??
        item?.releasedQuantity ??
        0
    );

    return Math.max(orderQty - releasedQty, 0);
};

const findFactoryProduct = (item, factoryOrderRecord) => {
    const itemKeys = getProductMatchKeys(item);

    return factoryOrderRecord?.products?.find((product) =>
        getProductMatchKeys(product).some((key) =>
            itemKeys.some((itemKey) => String(itemKey) === String(key))
        )
    );
};

const findFactoryProductItem = (productItem, factoryProduct) => {
    const itemKeys = getProductItemMatchKeys(productItem);

    return factoryProduct?.productItems?.find((factoryItem) =>
        getProductItemMatchKeys(factoryItem).some((key) =>
            itemKeys.some((itemKey) => String(itemKey) === String(key))
        )
    );
};

const getCurrentReleaseQuantity = (item) => {
    if (item?.isInCurrentOrder === false) {
        return 0;
    }

    const factoryReleasedQty = Number(item?.factoryReleasedQuantity ?? 0);

    if (factoryReleasedQty === 0) {
        return 0;
    }

    const lpoQty = Number(item?.lpoQuantity ?? 0);

    return Math.max(lpoQty - factoryReleasedQty, 0);
};

const getProductItems = (item) =>
    Array.isArray(item?.productItems)
        ? item.productItems
        : [];

const getActiveItemRequestedDeliveryDate = (product) => {
    const activeItem = product?.productItems?.find((productItem) =>
        Number(productItem?.currentReleaseQuantity ?? productItem?.factoryReleasedQuantity ?? 0) > 0
    );

    return activeItem?.requestedDeliveryDate ?? activeItem?.effectiveRequestedDeliveryDate;
};

const getLineListPrice = (item, product) => {
     if (item?.isInCurrentOrder === false) {
        return 0;
    }

     if (Number(product?.currentReleaseQuantity ?? 0) === 0) {
        return 0;
    }

    const productItems = getProductItems(item);

    if (productItems.length > 0) {
        return productItems.reduce((total, productItem) => {
            const matchingProductItem = findFactoryProductItem(productItem, product);
            const currentReleaseQty = Number(
                matchingProductItem?.currentReleaseQuantity ??
                matchingProductItem?.factoryReleasedQuantity ??
                productItem?.currentReleasedQuantity ??
                productItem?.factoryReleasedQuantity ??
                0
            );

            if (Number(matchingProductItem?.id ?? productItem?.id ?? 0) === 0) {
                return total;
            }

            if (currentReleaseQty === 0) {
                return total;
            }

            const listPrice = Number(
                matchingProductItem?.listPrice ??
                productItem?.listPrice ??
                0
            );

            return total + (listPrice * currentReleaseQty);
        }, 0);
    }

    const matchingProductItem = findFactoryProductItem(item, product);
    if (Number(matchingProductItem?.id ?? item?.id ?? 0) === 0) {
        return 0;
    }

    const listPrice = Number(
        matchingProductItem?.listPrice ??
        item?.listPrice ??
        0
    );
    const currentReleaseQty = Number(
        matchingProductItem?.currentReleaseQuantity ??
        matchingProductItem?.factoryReleasedQuantity ??
        product?.currentReleaseQuantity ??
        0
    );

    return listPrice * currentReleaseQty;
};

const getLineNetPrice = (item, product, values, currencyDetail) => {
    if (item?.isInCurrentOrder === false) {
        return 0;
    }

    const itemFactoryReleasedQty = Number(
        item?.factoryReleasedQuantity ?? 0
    );

    const productCurrentReleaseQty = Number(
        product?.currentReleaseQuantity ?? 0
    );

    if (productCurrentReleaseQty === 0) {
        return 0;
    }

    const productItems = getProductItems(item);

    if (productItems.length > 0) {
        const total = productItems.reduce((total, productItem) => {
            const matchingProductItem = findFactoryProductItem(productItem, product);

            if (Number(matchingProductItem?.id ?? productItem?.id ?? 0) === 0) {
                return total;
            }

            const factoryReleasedQty = Number(
                matchingProductItem?.currentReleaseQuantity ??
                matchingProductItem?.factoryReleasedQuantity ??
                productItem?.currentReleasedQuantity ??
                productItem?.factoryReleasedQuantity ??
                0
            );

            if (factoryReleasedQty === 0) {
                return total;
            }

            const unitPrice = Number(
                matchingProductItem?.unitPrice ??
                productItem?.unitPrice ??
                0
            );

            return total + (unitPrice * factoryReleasedQty);
        }, 0);

        return total;
    }

    const matchingProductItem = findFactoryProductItem(item, product);
    if (Number(matchingProductItem?.id ?? item?.id ?? 0) === 0) {
        return 0;
    }

    const unitPrice = Number(
        matchingProductItem?.unitPrice ??
        item?.unitPrice ??
        0
    );
    const currentReleaseQty = Number(
        matchingProductItem?.currentReleaseQuantity ??
        matchingProductItem?.factoryReleasedQuantity ??
        product?.currentReleaseQuantity ??
        0
    );

    return unitPrice * currentReleaseQty;
};
const FactoryOrderProductList = ({
    values,
    currencyDetail,
    EditOrderQuantity,
    rename,
    renameError,
    setOrderProductCount,
    onRename,
    onRenameBlur,
    onRenameChange,
    onRenameKeyDown,
    factoryOrderRecord,
    isFactoryOrderEdit,
    releaseForm,
    onProductDeliveryDateChange
}) => {
    const orderProducts = values?.products || [];

    const productRows = orderProducts
        .filter((item) => isFactoryOrderEdit || getRemainingReleaseQty(item) > 0)
        .map((item) => {
            const factoryReleasedQty = Number(
                item?.factoryReleasedQuantity ?? 0
            );
            const inCurrentOrder = item?.isInCurrentOrder !== false;

            return {
                ...item,

                quotedQuantity:
                    item?.quotedQuantity ??
                    item?.quantity ??
                    item?.qtyValues ??
                    0,

                customerOrderedQuantity:
                    item?.customerOrderedQuantity ??
                    item?.orderedQuantity ??
                    item?.quantity ??
                    0,

                releasedQuantity: item?.releasedQuantity ?? 0,

                currentReleasedQuantity:
                    !inCurrentOrder || factoryReleasedQty === 0
                        ? 0
                        : getCurrentReleaseQuantity(item),

                __isSavedOrderMark: true,
            };
        });

    useEffect(() => {
        setOrderProductCount(productRows?.length || 0);
    }, [productRows?.length, setOrderProductCount]);

    const getDateValue = (value, fallback) => {
        const dateValue = value || fallback;
        if (!dateValue) return null;
        const date = new Date(dateValue);
        return Number.isNaN(date.getTime()) ? null : date;
    };

    return (
        <div className="col-xxl-10 col-xl-10 col-lg-9 col-md-12 col-sm-12 col-xs-12 center-card order-products-grid-card">
            <div className="card">
                <div className="card-body p-0">
                    <div className="row">
                        <div className="col-12">
                            <div className="table-responsive">
                                <table className="table table-borderless order-products-grid">
                                    <thead>
                                        <tr>
                                            <th>Mark</th>
                                            <th>Model Number</th>
                                            <th>CO Qty</th>
                                            <th>Released Qty</th>
                                            <th>Current Release</th>
                                            <th>List Price</th>
                                            <th>Margin</th>
                                            <th>Net Price</th>
                                            <th>Req.Dely.Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {productRows?.length > 0 ? productRows?.map((item, index) => {
                                            const isSavedOrderMark = item?.__isSavedOrderMark === true;
                                             const product = findFactoryProduct(item, factoryOrderRecord);
                                            const lineListPrice = getLineListPrice(item ,product, values, currencyDetail);
                                            const lineNetPrice = getLineNetPrice(item ,product, values, currencyDetail);
                                            const requestedDeliveryDate =
                                                getActiveItemRequestedDeliveryDate(product) ??
                                                item?.requestedDeliveryDate ??
                                                item?.effectiveRequestedDeliveryDate ??
                                                product?.requestedDeliveryDate ??
                                                product?.effectiveRequestedDeliveryDate;
                                            return (
                                                <tr key={item?.id || index} aria-disabled={!isSavedOrderMark}>
                                                    <td className="product-mark-cell">
                                                        <div className="product-mark-main">
                                                            <div className="product-mark-thumb" aria-hidden="true">
                                                                <img src={Product} alt="" />
                                                            </div>

                                                            <span
                                                                className="product-mark-link"
                                                                title={item?.markName}
                                                                role="button"
                                                                tabIndex={0}
                                                                onClick={() => {
                                                                    EditOrderQuantity(item);
                                                                }}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === "Enter" || e.key === " ") {
                                                                        e.preventDefault();
                                                                        EditOrderQuantity(item);
                                                                    }
                                                                }}
                                                            >
                                                                {item?.markName}
                                                            </span>

                                                            <div className="product-mark-actions">
                                                                <button
                                                                    type="button"
                                                                    title="Rename"
                                                                    disabled={!isSavedOrderMark}
                                                                    onClick={() => onRename && onRename(item)}
                                                                >
                                                                    <img src={renameimg} alt="Rename" />
                                                                </button>
                                                            </div>
                                                        </div>

                                                        {/* Inline rename input — shown only for the row currently being renamed */}
                                                        {isSavedOrderMark && rename && getOrderProductId(rename) === getOrderProductId(item) && (
                                                            <div className="product-mark-rename-row mt-1">
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm"
                                                                    value={rename?.markName ?? ""}
                                                                    autoFocus
                                                                    onChange={(e) =>
                                                                        onRenameChange && onRenameChange({ ...rename, markName: e.target.value })
                                                                    }
                                                                    onBlur={() => onRenameBlur && onRenameBlur()}
                                                                    onKeyDown={(e) => onRenameKeyDown && onRenameKeyDown(e)}
                                                                />
                                                                {renameError && <p className="form-error">{renameError}</p>}
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td style={{ textAlign: "left" }}>{item?.productName}</td>
                                                    {/* <td style={{ textAlign: "right" }}>{item?.quoteQuantity ?? item?.quoteQuantity ?? item?.qtyValues ?? 0}</td> */}
                                                    <td style={{ textAlign: "right" }}>{item?.isInCurrentOrder === false ? 0 : (item?.currentOrderQuantity ?? item?.lpoQuantity ?? 0)}</td>
                                                    <td style={{ textAlign: "right" }}>{product?.factoryReleasedQuantity ?? item?.factoryReleasedQuantity ?? 0}</td>
                                            <td style={{ textAlign: "right" }}>{item?.isInCurrentOrder === false ? 0 : (product?.currentReleaseQuantity ?? item?.currentReleasedQuantity ?? 0)}</td>
                                                    <td style={{ textAlign: "right" }}>{FormatValueDecimal(CurrencyConvertion(lineListPrice, values?.conversionRate, currencyDetail))}</td>
                                                    <td style={{ textAlign: "right" }}>{item?.margin}</td>
                                                    <td style={{ textAlign: "right" }}>{FormatValueDecimal(CurrencyConvertion(lineNetPrice, values?.conversionRate, currencyDetail))}</td>
                                                    <td style={{ textAlign: "right" }}>
                                                     <DatePicker
                                                        selected={getDateValue(requestedDeliveryDate, releaseForm?.deliveryFromDate ?? releaseForm?.scheduledDeliveryDate)}
                                                        onChange={(date) => onProductDeliveryDateChange && onProductDeliveryDateChange(date, item)}
                                                        customInput={<ExampleCustomInput />}
                                                        dateFormat="dd/MM/yyyy"
                                                        disabled={factoryOrderRecord?.isLockedForEdit}
                                                      />
                                                    </td>
                                                </tr>
                                            )
                                        }) : (
                                            <tr>
                                                <td colSpan="9">
                                                    <div className="order-products-empty-state">
                                                        <strong>No marks added yet</strong>
                                                        <span>Select a quotation to load product marks for this order.</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="accordion account-summary-accordion my-2" id="orderaccSummaryAccordion">
                                <div className="card account-summary-card">
                                    <div className="card-header" id="headingTwo">
                                        <h2 className="mb-0">
                                            <button
                                                className="btn btn-link btn-block text-left account-summary-accordion-toggle"
                                                type="button"
                                                data-toggle="collapse"
                                                data-target="#collapseOne"
                                                aria-expanded="true"
                                                aria-controls="collapseOne"
                                            >
                                                <i className="fas fa-file-alt account-summary-accordion-icon" aria-hidden="true"></i>
                                                <span>Account Summary</span>
                                            </button>
                                        </h2>
                                    </div>

                                    <div
                                        id="collapseOne"
                                        className="collapse"
                                        aria-labelledby="headingOne"
                                        data-parent="#orderaccSummaryAccordion"
                                    >
                                        <div className="card-body">
                                            <div className="row account-summary-metrics m-2">
                                                <div className="col-12 col-sm-6 col-md-4 col-xl-2 account-summary-metric">
                                                    <label className="account-summary-metric-label">Credit Limit</label>
                                                    <p>0</p>
                                                </div>
                                                <div className="col-12 col-sm-6 col-md-4 col-xl-2 account-summary-metric">
                                                    <label className="account-summary-metric-label">Outstanding</label>
                                                    <p>0</p>
                                                </div>
                                                <div className="col-12 col-sm-6 col-md-4 col-xl-2 account-summary-metric">
                                                    <label className="account-summary-metric-label">Overdue</label>
                                                    <p>0</p>
                                                </div>
                                                <div className="col-12 col-sm-6 col-md-4 col-xl-2 account-summary-metric">
                                                    <label className="account-summary-metric-label">Pending Orders</label>
                                                    <p>0</p>
                                                </div>
                                                <div className="col-12 col-sm-6 col-md-4 col-xl-2 account-summary-metric">
                                                    <label className="account-summary-metric-label">Pending Delivery</label>
                                                    <p>0</p>
                                                </div>
                                                <div className="col-12 col-sm-6 col-md-4 col-xl-2 account-summary-metric">
                                                    <label className="account-summary-metric-label">Available Room</label>
                                                    <p>0</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FactoryOrderProductList;
